module.exports = __webpack_public_path__ + "img/cancel-24.ff05c360.svg";